import { Facebook, Instagram, Linkedin, Twitter, Mail } from "lucide-react";
import { BRAND } from "../../data";

const CONTACT_EMAIL = "sporter@socialimpactcle.com";

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "#" },
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Linkedin, label: "LinkedIn", href: "#" },
  { icon: Twitter, label: "Twitter / X", href: "#" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-navy text-white overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logo}
                alt="SocialImpactCLE logo"
                data-testid="footer-logo-img"
                className="h-14 w-14 rounded-xl bg-white object-contain p-1 ring-2 ring-white/10"
              />
              <span className="font-display font-extrabold tracking-tight text-2xl">
                SocialImpact<span className="text-brand-orange">CLE</span>
              </span>
            </div>
            <p className="mt-6 max-w-md text-white/60 text-lg leading-relaxed">
              {BRAND.tagline}
            </p>
          </div>

          <div className="flex flex-col md:items-end gap-6">
            <div className="flex gap-3">
              {SOCIALS.map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  data-testid={`social-${label.split(" ")[0].toLowerCase()}`}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white/75 transition-all duration-300 hover:bg-brand-orange hover:border-brand-orange hover:text-white hover:-translate-y-1"
                >
                  <Icon size={19} />
                </a>
              ))}
            </div>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email"
              className="group inline-flex items-center gap-2 text-white/75 transition-colors duration-300 hover:text-brand-orange"
            >
              <Mail size={16} className="text-brand-orange" />
              <span className="text-sm md:text-base">{CONTACT_EMAIL}</span>
            </a>
            <div className="flex gap-6 font-mono text-xs uppercase tracking-widest text-white/55">
              <a href="#" className="hover:text-white transition-colors" data-testid="footer-privacy">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-testid="footer-terms">
                Terms of Use
              </a>
            </div>
          </div>
        </div>

        {/* Massive watermark */}
        <div className="mt-16 md:mt-24 border-t border-white/10 pt-8">
          <p className="font-display font-black tracking-tighter text-white/[0.06] leading-none text-[16vw] md:text-[13rem] select-none pointer-events-none -mb-4 md:-mb-8">
            SocialImpactCLE
          </p>
          <p className="font-mono text-xs text-white/45 text-center md:text-left">
            © 2026 SocialImpactCLE. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
